<template>
  <div>
    <el-form ref="conditionForm" :model="condition" :rules="rules" label-width="100px">
      <el-form-item label="显示">
        <el-radio-group v-model="condition.is_visible">
          <el-radio :label="0">无需渲染</el-radio>
          <el-radio :label="1">渲染可见</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="显示方式" prop="show_type">
        <el-radio-group v-model="condition.show_type">
          <el-radio :label="10">页面上显示</el-radio>
          <el-radio :label="20">高级筛选</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="条件名" prop="name">
        <el-input v-model="condition.name"></el-input>
      </el-form-item>
      <el-form-item v-show="condition.is_visible" label="样式">
        <el-select v-model="condition.type" placeholder="请选择样式">
          <el-option label="输入框" :value="10"></el-option>
          <el-option label="下拉框" :value="20"></el-option>
          <el-option label="范围搜索" :value="30"></el-option>
          <el-option label="时间控件" :value="40"></el-option>
          <el-option label="外键下拉控件" :value="50"></el-option>
          <el-option label="复选框" :value="60"></el-option>
          <el-option label="外键复选框" :value="70"></el-option>
        </el-select>
      </el-form-item>
    
<!--       <el-form-item label="关联表单">
        <el-select v-model="condition.table" placeholder="请选择关联表单" @change="resetData()">
          <el-option v-for="item in tables" :label="item.name" :value="item"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="字段" prop="field">
        <el-select filterable v-model="condition.filter_fields" :multiple="fieldMultiplt" :multiple-limit="isFilterRange || isFilterDateRange ? 1 : 0"  placeholder="请选择" v-loading="loading" @change="selectField">
          <el-option
            v-for="item in fields"
            :label="item.field+item.title"
            :value="item.field_id">
            <span>{{ item.field }}（{{ item.title }}）</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="禁用选项" prop="forbidden_option" v-if="isFilterSelect">
        <el-select filterable v-model="condition.forbidden_option" multiple>
          <el-option
            v-for="item in currentSelectOptions"
            :label="item.name"
            :value="item.value">
            <span>{{ item.name }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="外键下拉控件" prop="key_condition" v-if="isFilterForeignKey">
        <el-input v-model="condition.key_condition" placeholder="筛选条件"></el-input>
      </el-form-item>
      <el-form-item label="选择层级父级ID字段（外键复选框）" v-if="condition.type == FILTER_FOREIGNKEYCHECKBOX && condition.show_type == 20">
        <el-select v-model="condition.table" placeholder="请选择字段" @change="selectForeignField">
          <el-option 
          v-for="item in foreign_fields" 
          :label="item.field+item.title" 
          :value="item.field">
          <span>{{ item.field }}（{{ item.title }}）</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="condition.is_visible && condition.type == FILTER_FOREIGNKEY" label="主字段" style="opacity:0;width:0;height:0">
        <el-select v-model="condition.show_name" placeholder="请选择" v-loading="loading">
          <el-option
            v-for="item in getKeyOptions(condition.filter_fields)"
            :label="item"
            :value="item">
            <span>{{ item }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="!condition.is_visible" label="运算方式">
        <el-radio class="radio" v-model="condition.is_code" :label="0">普通运算</el-radio>
        <el-radio class="radio" v-model="condition.is_code" :label="1">PHP语句</el-radio>
        <el-radio class="radio" v-model="condition.is_code" :label="2">等于登录用户信息</el-radio>
      </el-form-item>
      <el-form-item label="选择用户信息字段" v-show="condition.is_code == 2">
        <el-select v-loading="loading" v-model="condition.field_id" placeholder="请选择">
          <el-option
            v-for="item in user_info_fileds"
            :label="item.field+item.title"
            :value="item.field_id">
            <span>{{ item.field }}（{{ item.title }}）</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="!condition.is_visible && condition.is_code == 0" label="条件选择">
        <el-radio class="radio" v-model="condition.logic" label="=">等于</el-radio>
        <el-radio class="radio" v-model="condition.logic" label="<">小于</el-radio>
        <el-radio class="radio" v-model="condition.logic" label="<=">小于等于</el-radio>
        <el-radio class="radio" v-model="condition.logic" label=">">大于</el-radio>
        <el-radio class="radio" v-model="condition.logic" label=">=">大于等于</el-radio>
        <el-radio class="radio" v-model="condition.logic" label="<>">不等于</el-radio>
      </el-form-item>
      <el-form-item v-show="!condition.is_visible && condition.is_code != 2" label="条件默认值">
        <el-input type="textarea" v-model="condition.default"></el-input>
      </el-form-item>
      <el-form-item v-show="multipleSelect" label="是否多选">
        <el-select v-model="condition.is_multiple">
          <el-option label="否" :value="0"></el-option>
          <el-option label="是" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="!condition.is_visible" label="无视本条件的绑定权限规则">
        <el-input v-model.trim="condition.free_rule.name" class="fl h-40 w-150 m-r-10" :disabled="true" placeholder="绑定权限规则"></el-input>
        <el-button size="small" class="fl m-l-10" @click="openRule(form)">查找</el-button>
        <el-button size="small" class="fl m-l-10" @click="clearRule">清空</el-button>
      </el-form-item>
    </el-form>

    <rule-list
      ref="ruleList"
      @selectRule="selectRule"
      :title="title">
    </rule-list>
  </div>
</template>

<script>
  // itemChange作用解释：当切换筛选区配置时，会触发关联数据表select控件的change事件，这个不是切换数据表而处罚的，会导致已经选好的字段清空
  import http from '../../../assets/js/http'
  import ruleList from '../../Common/business/rule.vue'
  import modelConfig from '../../../config/modelConfig'
  import cmsConfig from '../../../config/cmsConfig'
  export default {
    name: 'conditionConfig',
    props: {
      condition: {
        type: Object,
        default() {
          return {}
        }
      },
      tables: {
        type: Array,
        default() {
          return []
        }
      },
      index: {
        type: Number,
        default() {
          return -1
        }
      },
      modelId: {
        type: Number,
        default() {
          return -1
        }
      }
    },
    data() {
      return {
        itemChange: false,
        loading: false,
        rules: {
          name: [
            { required: true, message: '请输入条件名称', trigger: 'blur' }
          ],
          field: [
            { required: true, message: '请选择字段', trigger: 'blur' }
          ],
          show_type: [
            { required: true, message: '请选择显示方式' }
          ]
        },
        fields: [],
        foreign_fields: [],
        user_info_fileds: [],
        selectOptions: {},
        currentSelectOptions: []
      }
    },
    methods: {
      async resetData() {
        if (this.fields && this.fields.length) {
          return
        }
        // this.condition.filter_fields = []
        let num = ''
        if (this.condition.type == this.FILTER_SELECT) {  // 下拉
          num = this.TYPE_SELECT
        } else if (this.condition.type == this.FILTER_FOREIGNKEY) { // 外键
          num = this.TYPE_FOREIGNKEY
        } else if (this.condition.type == this.FILTER_FOREIGNKEYCHECKBOX) { // 外键复选框
          num = this.TYPE_FOREIGNKEY
        } else if (this.condition.type == this.FILTER_CHECKBOX) { // 复选框
          num = this.TYPE_FOREIGNKEY
        }
        this.fields = await this.getFields(num)
        this.user_info_fileds = await this.getUserInfoFields(this.TYPE_SELECT)
      },
      async getFields(num) {
        if (!this.modelId) {
          return
        }
        const type = num || ''
        let arr = []
        this.loading = true
        let res = {}
        if (this.condition.type == this.FILTER_FOREIGNKEYCHECKBOX) {
          res = await this.apiGet(`cms/deals/fields/${this.modelId}?type=${type}&&is_key=1`)
        } else {
          res = await this.apiGet(`cms/deals/fields/${this.modelId}?type=${type}`)
        }
        this.loading = false
        return this.promiseHandler(arr, res)
      },
      async getUserInfoFields(num) {
        let arr = []
        const type = num || ''
        let res = {}
        res = await this.apiGet(`cms/deals/fields/1?type=${type}`)
        this.loading = false
        return this.promiseHandler(arr, res)
      },
      selectField(item) {
        if (this.itemChange ||
            (this.condition.type != this.FILTER_SELECT &&
            this.condition.type != this.FILTER_CHECKBOX &&
            this.condition.type != this.FILTER_FOREIGNKEY &&
            this.condition.type != this.FILTER_FOREIGNKEYCHECKBOX)) {
          return
        }
        if (this.condition.type == this.FILTER_SELECT) {  // 如果是下拉控件，请求选项值
          let id = this.condition.filter_fields
          this.setCurrentSelectOptions(id)
          this.condition.forbidden_option = []
        }
        _(this.fields).forEach((res) => {
          if (res.field_id == item) {
            this.condition.field_id = res.field_id
          }
        })
        if (this.condition.type == this.FILTER_FOREIGNKEYCHECKBOX && this.condition.field_id) {
          this.apiGet(`cms/deals/foreign_fields/${this.condition.field_id}`).then((res) => {
            if (res.code == 200) {
              // console.log(res.data)
              this.foreign_fields = res.data
            } else {
              _g.dealError(this, res)
            }
          })
        }
      },
      async setCurrentSelectOptions(id) {
        if (!_g.isRealEmpty(id)) {
          if (!this.selectOptions[id]) {
            this.selectOptions[id] = await this.getSelectOptions(id)
          }
          this.currentSelectOptions = this.selectOptions[id]
        } else {
          this.currentSelectOptions = []
        }
      },
      selectForeignField(item) {
        // console.log(item)
        _(this.fields).forEach((res) => {
          // console.log(res.field_id, item)
          if (res.field_id == this.condition.field_id) {
            this.condition.key_name = item
            // console.log(res)
          }
        })
      },
      async getSelectOptions(id) { // 获取有选项控件的选项值
        let res = await this.apiGet(`cms/deals/select_filter/${id}`)
        let data = this.promiseHandler(data, res)
        if (!data) {
          data = []
        }
        return data
      },
      getKeyOptions(fieldId) {  // 根据字段名获取外键显示名
        let keyOptions = []
        _(this.fields).forEach((res) => {
          if (res.field_id == fieldId && res.field_type == this.TYPE_FOREIGNKEY) {
            keyOptions = res.key_data
            return false
          }
        })
        return keyOptions
      },
      openRule() {
        this.$refs.ruleList.open()
      },
      selectRule(id, _else, title) {
        this.condition.free_rule.id = id
        this.condition.free_rule.name = _else
      },
      clearRule() {
        this.condition.free_rule.id = null
        this.condition.free_rule.name = ''
      }
    },
    created() {
      this.resetData()
      if (this.condition.type == this.FILTER_SELECT) {
        let id = this.condition.filter_fields
        if (!_g.isRealEmpty(id)) {
          this.setCurrentSelectOptions(this.condition.filter_fields)
        }
      }
    },
    computed: {
      fieldMultiplt() {
        let multiple = true
        if (this.condition.type == this.FILTER_SELECT ||
            this.condition.type == this.FILTER_FOREIGNKEY ||
            this.condition.type == this.FILTER_CHECKBOX ||
            this.condition.type == this.FILTER_FOREIGNKEYCHECKBOX) {
          multiple = false
        }
        if (this.condition.is_visible == 0) {
          multiple = true
        }
        return multiple
      },
      isFilterSelect() {
        return this.condition.type == this.FILTER_SELECT
      },
      isFilterForeignKey() {
        return this.condition.type == this.FILTER_FOREIGNKEY
      },
      isFilterRange() {
        return this.condition.type == this.FILTER_RANGE
      },
      isFilterDateRange() {
        return this.condition.type == this.FILTER_DATERANGE
      },
      multipleSelect() {
        return this.condition.is_visible == 1 && this.condition.type == this.FILTER_SELECT
      }
    },
    watch: {
      'index'() {
        this.itemChange = true
        setTimeout(() => {
          this.itemChange = false
        }, 1000)
      },
      'condition.is_visible'() {
        if (this.itemChange) {
          return
        }
        if (this.condition.is_visible == 0 && this.condition.type == 20) {
          this.condition.filter_fields = []
        }
        this.condition.default = ''
      },
      async 'condition.is_code'() {
        if (this.itemChange) {
          return
        }
        if (this.condition.is_code == 1) {  // 若运算方式是php语句，默认填充下列代码
          this.condition.default = '$where[$v]="";'
        } else {
          this.condition.default = ''
        }
        if (this.condition.is_code == 2) {
          this.user_info_fileds = await this.getUserInfoFields(this.TYPE_SELECT)
          // console.log(this.user_info_fileds)
        } else {
          this.condition.field_id = 0
        }
      },
      async 'condition.type'() {
        if (this.condition.type == this.FILTER_INPUT) { // 输入框
          this.fields = await this.getFields()
        } else if (this.condition.type == this.FILTER_SELECT) { // 下拉框
          this.fields = await this.getFields(this.TYPE_SELECT)
        } else if (this.condition.type == this.FILTER_CHECKBOX) { // 复选框
          this.fields = await this.getFields(this.TYPE_CHECKBOX)
        } else if (this.condition.type == this.FILTER_FOREIGNKEYCHECKBOX) { // 外键复选框
          this.fields = await this.getFields(this.TYPE_CHECKBOX)
        } else if (this.condition.type == this.FILTER_FOREIGNKEY) { // 外键
          this.fields = []
          let keyFields = await this.getFields()
          _(keyFields).forEach((res) => {
            if (res.field_type == this.TYPE_FOREIGNKEY) {
              this.fields.push(res)
            }
          })
        } else {
          this.fields = await this.getFields()
        }
        if (this.itemChange) {
          return
        }
        this.condition.filter_fields = []
        if (this.condition.type == this.FILTER_INPUT) { // 输入框
          this.condition.field_id = ''
          // this.fields = await this.getFields()
        } else if (this.condition.type == this.FILTER_SELECT) { // 下拉框
          // this.fields = await this.getFields(this.TYPE_SELECT)
        } else if (this.condition.type == this.FILTER_CHECKBOX) { // 复选框
          // this.fields = await this.getFields(this.TYPE_CHECKBOX)
        } else if (this.condition.type == this.FILTER_FOREIGNKEYCHECKBOX) { // 外键复选框
          // this.fields = await this.getFields(this.TYPE_CHECKBOX)
        } else if (this.condition.type == this.FILTER_FOREIGNKEY) { // 外键
          // this.fields = []
          // let keyFields = await this.getFields()
          // _(keyFields).forEach((res) => {
          //   if (res.field_type == this.TYPE_FOREIGNKEY) {
          //     this.fields.push(res)
          //   }
          // })
        } else {
          // this.fields = await this.getFields()
        }
      }
    },
    components: {
      ruleList
    },
    mixins: [http, modelConfig, cmsConfig]
  }
</script>


// WEBPACK FOOTER //
// conditionConfig.vue?5d6885d6